/* ============================================================
   GOB Club prices follow the cart (V93, 29 Sep 2026)

   One class on <html> decides every member price on the site:
     html.gob-club-on  → the shopper gets the Club discount on this order
                         (signed-in member, or GOB Club in the cart).
   Liquid sets it on first paint (layout/theme.liquid). This script keeps it in
   step afterwards: every cart event the theme, the drawer and the PDP Club
   card fire, plus the back button (bfcache). Prices themselves are printed in
   both versions by Liquid; CSS (gob-club-prices.css and the PDP snippets)
   shows one or the other, so the switch is instant and never flashes.

   Members (html[data-gob-member]) are always on.
   Fires `gob:club-prices` {on} on document whenever the state changes.
   ============================================================ */
(function () {
  'use strict';
  var PID = 10601114403149;
  var root = document.documentElement;

  function isMember() { return root.hasAttribute('data-gob-member'); }

  function hasClub(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) === String(PID)) return true;
    }
    return false;
  }

  function set(on) {
    on = !!on || isMember();
    if (root.classList.contains('gob-club-on') === on) return;
    root.classList.toggle('gob-club-on', on);
    try { document.dispatchEvent(new CustomEvent('gob:club-prices', { detail: { on: on } })); } catch (e) {}
  }

  function sync(cart) { if (cart && cart.items) set(hasClub(cart)); }

  function read() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(sync)
      .catch(function () {});
  }

  ['cart:updated', 'cart:build', 'cart:refresh', 'ajaxProduct:added', 'cart:open', 'CartDrawer:open'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var c = e && e.detail && e.detail.cart;
      if (c && c.items) { sync(c); return; }
      setTimeout(read, 150);
      setTimeout(read, 1500);
    });
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) read(); });

  window.GOBClubPrices = { sync: sync, read: read, set: set };
})();

/* ============================================================
   One-tap Club join from the thank-you page (V95, 29 Sep 2026)

   The thank-you invite button opens
     /discount/<CODE>?redirect=/pages/membership?gob_join=1&code=<CODE>
   The /discount/ hop puts the personal free-month code on the session; this
   script then puts EXACTLY ONE GOB Club membership in the cart (adds it, or
   trims duplicates: a second tap must never create a second subscription)
   and goes straight to checkout, where the Club shows at €0.00.
   If anything fails, the overlay is removed and the shopper is simply on the
   Club page with the code already applied (the old flow).
   ============================================================ */
(function () {
  'use strict';
  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { return; }
  if (q.get('gob_join') !== '1') return;
  var VID = 53631345131853, PLAN = 692298416461, PID = 10601114403149;
  var code = String(q.get('code') || '').toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 40);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var ov = document.createElement('div');
  ov.setAttribute('role', 'status');
  ov.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:#fff;display:flex;align-items:center;justify-content:center;flex-direction:column;gap:10px;font:700 17px/1.3 Barlow,Helvetica,Arial,sans-serif;color:#111;text-align:center;padding:24px';
  ov.innerHTML = '<span style="font-size:15px;letter-spacing:.12em;text-transform:uppercase;color:#1E7D3F">&#10003; Your order qualified</span><span>Getting your free GOB Club month ready&hellip;</span>';
  function show() { if (document.body && !ov.parentNode) document.body.appendChild(ov); }
  if (document.body) show(); else document.addEventListener('DOMContentLoaded', show);

  function j(url, body) {
    return fetch(root + url, body ? {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    } : { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  j('cart.js')
    .then(function (cart) {
      var lines = (cart.items || []).filter(function (i) { return String(i.product_id) === String(PID); });
      if (!lines.length) return j('cart/add.js', { items: [{ id: VID, quantity: 1, selling_plan: PLAN }] });
      var chain = Promise.resolve();
      lines.forEach(function (l, n) {
        var want = n === 0 ? 1 : 0;
        if (l.quantity !== want) chain = chain.then(function () { return j('cart/change.js', { id: l.key, quantity: want }); });
      });
      return chain;
    })
    .then(function () {
      location.replace('/checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
    })
    .catch(function () {
      if (ov.parentNode) ov.parentNode.removeChild(ov);
    });
})();
